import React from 'react';
import Navbar from '../../components/navbar';
import FormularioEditarEmpresa from '../../components2/formularioEditarEmpresa';

function EditarEmpresa () {
    return (
        <FormularioEditarEmpresa />
    )
}

export default EditarEmpresa;